import { api_request } from '../axios_client';
import { handleError } from '../common';
import * as Constants from '../constants';

const attachmentIdUploadPost = async (file_type, id, file, options) => {
  const resourcePath = `${Constants.PATH.ATTACHMENT.attachment}/${id}${Constants.PATH.ATTACHMENT.upload}`;

  try {
    const res = await api_request({
      methodType: 'post',
      resourcePath,
      params: { file_type },
      data: { file },
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const attachmentDeletePatch = async (file_id, options) => {
  const resourcePath = `${Constants.PATH.ATTACHMENT.delete}`;

  try {
    const res = await api_request({
      methodType: 'patch',
      resourcePath,
      params: { file_id },
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const attachmentGet = async (fileName, referenceId, fileType, options) => {
  const resourcePath = `${Constants.PATH.ATTACHMENT.attachment}`;

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params: { fileName, referenceId, fileType },
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const attachmentDownloadZipGet = async (reference_id, file_types, options) => {
  const resourcePath = `${Constants.PATH.ATTACHMENT.downloadZip}`;
  file_types = file_types.toString();

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params: { reference_id, file_types },
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

const attachmentHistoryDownloadZipGet = async (reference_id, file_types, reference_type, options) => {
  const resourcePath = `${Constants.PATH.ATTACHMENT.downloadHistoryZip}`;
  file_types = file_types.toString();

  try {
    const res = await api_request({
      methodType: 'get',
      resourcePath,
      params: { reference_id, file_type: file_types, reference_type },
      options
    });
    return res;
  } catch (err) {
    handleError(err);
  }
};

export {
  attachmentIdUploadPost,
  attachmentDeletePatch,
  attachmentGet,
  attachmentDownloadZipGet,
  attachmentHistoryDownloadZipGet
};
